import { FieldMapper } from '@/modules/common/utils/entity-changes-manager';

import { Client } from '../types/clients.types';

export interface ClientFieldValues {
  name: string;
}

/**
 * Field mapper implementation for Client entities
 */
export class ClientFieldMapper implements FieldMapper<Client, ClientFieldValues> {
  getFieldValue(client: Client, field: keyof ClientFieldValues): string {
    switch (field) {
      case 'name':
        return client.name;
      default:
        throw new Error(`Unknown field: ${String(field)}`);
    }
  }

  getTrackableFields(client: Client): ClientFieldValues {
    return {
      name: client.name,
    };
  }
}
